import React, { Component } from 'react';
import { pure } from "recompose"
import { Async } from 'react-select';
import 'react-select/dist/react-select.css';
import './select.css'

const getOptions = () => {
    return fetch('https://admin.birdietime.com/en/api-public/v2/courses?registration')
        .then((response) => {
            return response.json();
        }).then((json) => {
            return { options: json };
        });
}


class ClubSelect extends Component {

    render() {
        
        return (
            <Async 
                {...this.props}
                labelKey="title"
                valueKey="id"
                loadOptions={getOptions}
                autosize={false}
            />
        )
    }
}

export default pure(ClubSelect);




// WEBPACK FOOTER //
// ./src/components/ClubSelect/ClubSelect.js